"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PulldownMenu = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const pulldown_menu_style_1 = __importDefault(require("./pulldown.menu.style"));
const veneer_1 = __importDefault(require("../veneer/veneer"));
const constants_1 = require("../constants");
class PulldownMenu extends react_1.default.PureComponent {
    constructor(props) {
        super(props);
        this.buttonData = this.props.buttonElement.getBoundingClientRect();
        this.state = {
            invisible: true,
            top: null,
            left: null,
            right: null
        };
        this.getMinWidth = () => {
            const { width } = this.props.buttonElement.getBoundingClientRect();
            const maxWidth = window.innerWidth - constants_1.VIEWPORT_MARGIN - constants_1.VIEWPORT_MARGIN;
            return width > maxWidth ? maxWidth : width;
        };
        this.componentDidMount = () => {
            if (this.state.invisible) {
                this.setState({
                    invisible: false,
                    ...this.getMenuY(),
                    ...this.getMenuX()
                });
            }
        };
        this.render = () => {
            const { classes, children, handleCollapse } = this.props;
            const veneerProps = {
                handleCollapse,
                invisible: true,
                contentPosition: {
                    top: this.state.top,
                    left: this.state.left,
                    right: this.state.right,
                    bottom: this.state.bottom
                }
            };
            const rootProps = {
                className: classes.root,
                'data-is-invisible': this.state.invisible
            };
            const menuProps = {
                role: 'menu',
                tabIndex: 0,
                className: classes.menu,
                onClick: handleCollapse,
                ref: this.setMenuRef,
                style: {
                    minWidth: this.getMinWidth()
                }
            };
            return (jsx_runtime_1.jsx(veneer_1.default, Object.assign({}, veneerProps, { children: jsx_runtime_1.jsx("div", Object.assign({}, rootProps, { children: jsx_runtime_1.jsx("ul", Object.assign({}, menuProps, { children: children }), void 0) }), void 0) }), void 0));
        };
        this.setMenuRef = this.setMenuRef.bind(this);
        this.getMenuY = this.getMenuY.bind(this);
        this.getMenuX = this.getMenuX.bind(this);
    }
    getMenuY() {
        const menuHeight = this.menu.scrollHeight;
        if (menuHeight > window.innerHeight - constants_1.VIEWPORT_MARGIN - constants_1.VIEWPORT_MARGIN)
            return {
                top: constants_1.VIEWPORT_MARGIN
            };
        if (menuHeight >
            window.innerHeight -
                this.buttonData.top -
                this.buttonData.height -
                constants_1.VIEWPORT_MARGIN)
            return {
                top: window.innerHeight - menuHeight - constants_1.VIEWPORT_MARGIN
            };
        return {
            top: this.buttonData.top + this.buttonData.height
        };
    }
    getMenuX() {
        const menuData = this.menu.getBoundingClientRect();
        if (menuData.width >
            window.innerWidth - this.buttonData.left - constants_1.VIEWPORT_MARGIN)
            return {
                left: this.buttonData.left < constants_1.VIEWPORT_MARGIN ? constants_1.VIEWPORT_MARGIN : null,
                right: constants_1.VIEWPORT_MARGIN
            };
        return {
            left: this.buttonData.left < constants_1.VIEWPORT_MARGIN
                ? constants_1.VIEWPORT_MARGIN
                : this.buttonData.left,
            right: null
        };
    }
    setMenuRef(el) {
        this.menu = el;
    }
}
exports.PulldownMenu = PulldownMenu;
PulldownMenu.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    children: prop_types_1.default.node.isRequired,
    handleCollapse: prop_types_1.default.func.isRequired,
    buttonElement: prop_types_1.default.object.isRequired
};
exports.default = react_jss_1.default(pulldown_menu_style_1.default)(PulldownMenu);
//# sourceMappingURL=pulldown.menu.js.map